// extracted by mini-css-extract-plugin
export default {"root":"IconCheckBlue_root__BWAHV"};